import React from "react";

//////////////////////////////////////////////
//// HOME PAGE RECCORDING TO ROLE ////
//////////////////////////////////////////////
export class Dashboard extends React.Component {
  componentDidMount() {
    const {history} = this.props;
    const permissions = localStorage.getItem("role");

    if (permissions === "admin") {
      history.replace(`/partners`);
    } else if (permissions === "partner") {
      history.replace(`/activation`);
    } else if (permissions === null) {
      history.replace(`/login`);
    }
  }

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/containers/Dashboard.js